/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/DashboardAdmin";
import AuthLayout from "layouts/DashboardAuth";

import VoiceConditioning from "views/pages/LandingPage/ProductPage/VoiceConditioning/Index";
import Elcar from "views/pages/LandingPage/ProductPage/Elcar/Index";
import Checkout from "views/pages/LandingPage/Checkout/Index";
import VcPaymentConfirmed from "views/pages/LandingPage/InstructionPage/VoiceConditioning/Index";
import { ProductProvider } from 'views/pages/LandingPage/Context/productContext.js';
import { UserImageProvider } from "views/pages/LandingPage/Context/UserImageContext";
import FAQ from "views/pages/LandingPage/FAQ/index";
import Terms from "views/pages/LandingPage/Terms/index";
import PrivacyPolicy from "views/pages/LandingPage/PrivacyPolicy/index";
import Hotpage from "views/pages/LandingPage/Hotpage/Index";

import Landing from "views/pages/LandingPage/Home/Index";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ProductProvider>
      <UserImageProvider>
        <Routes>
            <Route path="/home" exact element={<Landing />} />
            <Route path="/vc-payment-confirmed" element={<VcPaymentConfirmed />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/waitlist" element={<Hotpage/>}/>

            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/auth/*" element={<AuthLayout />} />
            {/*<Route path="*" element={<Navigate to="/admin/index" replace />} /> */}
            <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>

      </UserImageProvider>


    </ProductProvider>
    
  </BrowserRouter>
);
